export default "__VITE_ASSET__87618634__"